// @vendors
import React, { useState } from 'react';

// @interfaces
interface UserMessageProps {
  content: string;
  timestamp?: string;
  profileImage?: string;
}

const UserMessage: React.FC<UserMessageProps> = ({ content, timestamp }) => {
  const [imageUrl, setImageUrl] = useState<string | null>(null);


  return (
    <div className="flex justify-end mb-4">
      <div className="flex flex-col items-end">
        <div className="flex items-start">
          <div className="bg-xervix-primary text-white p-3 rounded-tl-lg rounded-tr-lg rounded-bl-lg max-w-[80%] mr-2">
            <p className="whitespace-pre-wrap break-words">{content}</p>
          </div>
          <div className="w-[40px] h-[40px] rounded-full overflow-hidden ml-2">
            {imageUrl ? (
              <img
                src={imageUrl}
                alt="Perfil de usuario"
                className="w-full h-full object-cover"
                onError={(e) => {
                  console.error('Error al cargar la imagen de perfil del usuario');
                  // Si hay error, mostrar el placeholder
                  setImageUrl(null);
                }}
              />
            ) : (
              <div className="w-full h-full bg-xervix-primary flex items-center justify-center text-white">
                <span className="text-sm font-bold">Tú</span>
              </div>
            )}
          </div>
        </div>
        {timestamp && (
          <span className="text-xs text-xervix-text-muted dark:text-xervix-text-muted-dark mt-1">
            {timestamp}
          </span>
        )}
      </div>
    </div>
  );
};

export default UserMessage;
